
export class ActivityType {
  id: number;
  name: string;
}
